export const LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP = '/agent-hub/complete-account-setup'
